import { render } from "./MusubiStatusPill.vue?vue&type=template&id=6960b768&scoped=true"
import script from "./MusubiStatusPill.vue?vue&type=script&lang=js"
export * from "./MusubiStatusPill.vue?vue&type=script&lang=js"

import "./MusubiStatusPill.vue?vue&type=style&index=0&id=6960b768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6960b768"]])

export default __exports__